import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ContactListModal(props) {
    const {open, close, confirm, text} = props;
  return (
    <div>
      <Dialog
        open={open}
        onClose={close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Contact List"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
             {text ? text : "This is not in your contacts, Do you want to save it?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={close}>No</Button>
          <Button onClick={confirm} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
